import React from 'react';

const HeroSection: React.FC = () => {
  return (
    <section className="relative w-full">
      {/* Background Video */}
      <video
        className="w-full h-auto block"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src="/videos/osmia.mp4" type="video/mp4" />
        {/* Fallback image if video fails to load */}
        <img
          src="/images/shot1-1.jpg"
          alt="Hero Background"
          className="w-full h-auto block"
        />
      </video>
    </section>
  );
};

export default HeroSection;
